import React from 'react';
import { Switch, Redirect } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import WithFeature from 'components/WithFeature';
import Dashboard from './containers/Dashboard';
import ConnectCardEditor from './containers/ConnectCardEditor';
import ConnectWidgetEditor from './containers/ConnectWidgetEditor';
import ConnectWebsiteSetup from './containers/ConnectWebsiteSetup';
import FEATURES from 'constants/features';
import { MODULES, ACTIONS, ProtectedRoute } from 'components/Access';

const ConnectRoutes = () => {
  const [t] = useTranslation();

  return (
    <WithFeature
      feature={FEATURES.CONNECT_CARD}
      message={t(
        'common:no-feature-access',
        'You do not have access to this feature.',
      )}
    >
      <Switch>
        <ProtectedRoute
          module={MODULES.CONNECT_CARDS}
          action={ACTIONS.MODIFY}
          path="/connect/website/setup"
          component={ConnectWebsiteSetup}
        />
        <ProtectedRoute
          exact
          module={MODULES.CONNECT_CARDS}
          path={['/connect/cards', '/connect/widgets']}
          component={Dashboard}
        />
        <ProtectedRoute
          module={MODULES.CONNECT_CARDS}
          action={ACTIONS.MODIFY}
          path="/connect/widgets/:id/:stepId?"
          component={ConnectWidgetEditor}
        />
        <ProtectedRoute
          module={MODULES.CONNECT_CARDS}
          action={ACTIONS.MODIFY}
          path="/connect/cards/:id"
          component={ConnectCardEditor}
        />
        <Redirect to="/connect/cards" from="/connect" />
      </Switch>
    </WithFeature>
  );
};

export default ConnectRoutes;
